
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/donate/[slug]",
      function () {
        return require("private-next-pages/donate/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/donate/[slug]"])
      });
    }
  